import styled from 'styled-components';

export default styled.div`
  display: grid;
  background-color: ${(props) => props.theme.colors.background};
  border-radius: ${(props) => props.theme.sizes.borderRadius};
  border: 1px solid ${(props) => props.theme.colors.border};
`;
